import React, { SyntheticEvent, useState } from 'react'
import BasicTabsWithSearch from '../../../components/tabs/basic-tabs-with-search/basic-tabs-with-search.component'
import { equipmentTabs } from '../equipment.constants'
import TabPanel from '../../../components/tabs/tab-panel/tab-panel.component'
import { Box, Stack, useTheme } from '@mui/material'
import EquipmentList from '../equipment-list/equipment-list.component'
import AddButton from 'components/add-button/add-button.component'
import EquipmentAddDialog from '../equipment-add-dialog/equipment-add-dialog.component'

const EquipmentSelection = () => {
  const theme = useTheme()
  const [tabsValue, setTabsValue] = useState(0)
  const [addDialogOpen, setAddDialogOpen] = useState(false)
  const equipmentType = tabsValue === 0 ? 'TRACTOR' : 'TRAILER'

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setTabsValue(newValue)
  }

  return (
    <Stack
      justifyContent="space-between"
      sx={{
        height: '100%',
        minHeight: 0,
        flexDirection: 'column',
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <BasicTabsWithSearch
          tabs={equipmentTabs}
          value={tabsValue}
          handleChange={handleChange}
        >
          <TabPanel value={tabsValue} index={0}>
            <EquipmentList type="TRACTOR" isActive={tabsValue === 0} />
          </TabPanel>
          <TabPanel value={tabsValue} index={1}>
            <EquipmentList type="TRAILER" isActive={tabsValue === 1} />
          </TabPanel>
        </BasicTabsWithSearch>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: theme.palette.common.white,
          borderTop: `1px solid ${theme.palette.divider}`,
          mt: 'auto',
          flexShrink: 0,
          pt: 0.5,
          pb: 1,
          px: 0.5,
          minHeight: 60,
        }}
      >
        <AddButton
          label="Add Equipment"
          handleClick={() => setAddDialogOpen(true)}
        />
      </Box>
      <EquipmentAddDialog
        open={addDialogOpen}
        equipmentType={equipmentType}
        handleClose={() => setAddDialogOpen(false)}
      />
    </Stack>
  )
}

export default EquipmentSelection
